module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.d4cf8e34.svg";